/**
 * Google Calendar 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <GoogleCalendarIcon className="w-8 h-8" />
 * <GoogleCalendarIcon className="w-12 h-12" />
 * ```
 */
export function GoogleCalendarIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Google Calendar icon"
      role="img"
    >
      <title>Google Calendar</title>
      <g id="Google Calender">
        <g id="Vector">
          <path
            d="M23.3685 8.63152L16.737 7.8947L8.63166 8.63152L7.8947 16L8.63152 23.3685L16 24.2895L23.3685 23.3685L24.1053 15.8159L23.3685 8.63152Z"
            fill="white"
          />
          <path
            d="M11.6545 20.0636C11.1038 19.6915 10.7224 19.1482 10.5142 18.4297L11.7927 17.9029C11.9088 18.345 12.1114 18.6876 12.4006 18.9308C12.688 19.1739 13.038 19.2936 13.447 19.2936C13.8651 19.2936 14.2244 19.1665 14.5245 18.9123C14.8247 18.658 14.9759 18.3338 14.9759 17.9415C14.9759 17.54 14.8174 17.212 14.5006 16.9579C14.1838 16.7038 13.7859 16.5765 13.3106 16.5765H12.572V15.3111H13.235C13.6439 15.3111 13.9885 15.2006 14.2685 14.9795C14.5485 14.7585 14.6885 14.4564 14.6885 14.0714C14.6885 13.7288 14.5632 13.4561 14.3127 13.2517C14.0623 13.0473 13.7453 12.9441 13.3603 12.9441C12.9845 12.9441 12.6861 13.0436 12.465 13.2444C12.2439 13.4451 12.0836 13.692 11.9824 13.983L10.717 13.4562C10.8845 12.9809 11.1923 12.5609 11.6435 12.198C12.0948 11.8351 12.6714 11.6527 13.3714 11.6527C13.8889 11.6527 14.355 11.7523 14.7677 11.953C15.1803 12.1538 15.5045 12.432 15.7385 12.7856C15.9724 13.1411 16.0885 13.5391 16.0885 13.9811C16.0885 14.4324 15.9798 14.8136 15.7624 15.1268C15.545 15.44 15.2779 15.6794 14.9611 15.8471V15.9226C15.3792 16.0976 15.72 16.3647 15.9889 16.7239C16.2561 17.0832 16.3905 17.5124 16.3905 18.0135C16.3905 18.5145 16.2633 18.9621 16.0091 19.3545C15.7549 19.747 15.403 20.0564 14.9573 20.2811C14.5097 20.5058 14.0068 20.62 13.4486 20.62C12.8021 20.6218 12.2053 20.4358 11.6545 20.0636Z"
            fill="#1A73E8"
          />
          <path
            d="M19.5 13.7195L18.1036 14.7345L17.4018 13.6698L19.92 11.8535H20.8853V20.4211H19.5V13.7195Z"
            fill="#1A73E8"
          />
          <path
            d="M23.3685 30L30 23.3685L26.6842 21.8948L23.3685 23.3685L21.8948 26.6842L23.3685 30Z"
            fill="#EA4335"
          />
          <path
            d="M7.15788 26.6842L8.63152 30H23.3685L23.3685 23.3685H8.63152L7.15788 26.6842Z"
            fill="#34A853"
          />
          <path
            d="M4.21046 2C2.98924 2 2 2.98924 2 4.21046V23.3683L5.31576 24.842L8.63152 23.3685L8.63166 8.63152H23.3685L24.842 5.31576L23.3685 2H4.21046Z"
            fill="#4285F4"
          />
          <path
            d="M2 23.3683V27.7895C2 29.0109 2.98924 30 4.21046 30H8.63152V23.3685L2 23.3683Z"
            fill="#188038"
          />
          <path
            d="M23.3685 8.63152V23.3685L30 23.3685V8.63152L26.6842 7.15788L23.3685 8.63152Z"
            fill="#FBBC04"
          />
          <path
            d="M30 8.63152V4.21046C30 2.9891 29.0108 2 27.7895 2H23.3685V8.63152H30Z"
            fill="#1967D2"
          />
        </g>
      </g>
    </svg>
  );
}
